import AdManager from './';

window.adManager = new AdManager(window);



// WEBPACK FOOTER //
// ./src/ads/entry.js